const lightbox = document.querySelector('.events-list__lightbox');
if (lightbox) {
  const titleEl = lightbox.querySelector('.events-list__lightbox-title');
  const gridEl = lightbox.querySelector('.events-list__lightbox-grid');
  const closeButton = lightbox.querySelector('.events-list__lightbox-close');
  const backdrop = lightbox.querySelector('.events-list__lightbox-backdrop');

  const openLightbox = (title, items) => {
    titleEl.textContent = title || '';
    gridEl.innerHTML = '';

    items.forEach((item) => {
      if (item.type === 'video' && item.src) {
        const wrapper = document.createElement('div');
        wrapper.className = 'events-list__lightbox-video';
        const iframe = document.createElement('iframe');
        iframe.src = item.src;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        wrapper.appendChild(iframe);
        gridEl.appendChild(wrapper);
      } else if (item.type === 'image' && item.src) {
        const img = document.createElement('img');
        img.src = item.src;
        img.alt = '';
        img.loading = 'lazy';
        gridEl.appendChild(img);
      }
    });

    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    lightbox.hidden = true;
    gridEl.innerHTML = '';
    document.body.style.overflow = '';
  };

  document.querySelectorAll('.events-list__explore').forEach((button) => {
    button.addEventListener('click', () => {
      let items = [];
      try {
        items = JSON.parse(button.dataset.gallery || '[]');
      } catch (error) {
        return;
      }
      if (!Array.isArray(items) || items.length === 0) return;
      openLightbox(button.dataset.eventTitle, items);
    });
  });

  closeButton?.addEventListener('click', closeLightbox);
  backdrop?.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
  });
}
